import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PagePathHighlightService {

  public isActive = false;

  constructor() { }
}
